import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-collect_null",
  "use": "icon-collect_null-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-collect_null\">\n\t<path fill=\"none\" d=\"M0,0H24V24H0Z\" />\n\t<path d=\"M18,10.78l-4.21-.55L12.07,6.5l-1.84,3.67L6,10.57l3.07,2.82-.89,4,3.74-1.92,3.67,2.05-.76-4ZM12,14,9.76,15.14l.53-2.33L8.48,11.16,11,10.92,12,8.78l1,2.18,2.47.33-1.86,1.58.44,2.35Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol